import { HTTPRequestMethods } from '../../Shared/httpRequestMethods';
import { convertObjectKeysToSnakeCase } from '../../Shared/ConvertObjectKeysToSnakeCase';
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getArchivedJobProspects = ({ onResponse, onError, body }) => {
  const params = new URLSearchParams();
  if (body?.pageNumber) {
    params.append('page_number', body.pageNumber);
  }

  const url = `/api/archived_job_prospects${params.toString() ? `?${params.toString()}` : ''}`;

  fetch(
    url,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const unarchiveJobProspect = ({ body, onResponse, onError }) => {
  fetch(
    `/api/archived_job_prospects/unarchive_job_prospect`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const bulkUnarchiveJobProspects = ({ body, onResponse, onError }) => {
  fetch(
    `/api/archived_job_prospects/bulk_unarchive_job_prospects`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
